/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Emptystate_Closeddescription3Inputs */

const en_coinvestments_prospects_emptystate_closeddescription3 = /** @type {(inputs: Coinvestments_Prospects_Emptystate_Closeddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deal is closed, so prospects can no longer be added`)
};

/**
* | output |
* | --- |
* | "This deal is closed, so prospects can no longer be added" |
*
* @param {Coinvestments_Prospects_Emptystate_Closeddescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_emptystate_closeddescription3 = /** @type {((inputs?: Coinvestments_Prospects_Emptystate_Closeddescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Emptystate_Closeddescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_emptystate_closeddescription3(inputs)
});
export { coinvestments_prospects_emptystate_closeddescription3 as "coInvestments_prospects_emptyState_closedDescription" }